import axios from 'axios';

import { db } from '../utils/configureFirebase';
import { API_BASE_URL } from '../styles/constant';

const generateCandidateID = async (jypCity) => {
  try {
    const cityRegistrationCountRef = db.collection('citiesRegistrationCount').doc(jypCity);

    const cityRegistrationCountSnapshot = await cityRegistrationCountRef.get();
    if (!cityRegistrationCountSnapshot.exists) {
      return null;
    }
    const { count } = cityRegistrationCountSnapshot.data();

    const candidateID = `JYP-${jypCity.substring(0, 3)}-2018-${count + 1}`;

    await cityRegistrationCountRef.update({
      count: count + 1,
    });

    return candidateID;
  } catch (error) {
    return null;
  }
};

export const shortlistCandidates = async ({ ids = [], shortlistStage }) => {
  if (ids.length < 1) {
    throw new Error('select candidates to shortlist');
  }

  const shortlistErrors = {};

  // eslint-disable-next-line
  for (const id of ids) {
    try {
      const candidate = db.collection('candidates').doc(id);
      // eslint-disable-next-line no-await-in-loop
      const candidateSnapshot = await candidate.get();
      if (!candidateSnapshot.exists) {
        shortlistErrors[id] = `Candidate with id ${id} does not exist`;
      } else {
        const candidateData = candidateSnapshot.data();

        let stagesSelected;
        let updatedCandidateID;

        if (shortlistStage === 'knowledgeTest') {
          const { candidateID, jypCity } = candidateData;

          if (!candidateID) {
            // eslint-disable-next-line no-await-in-loop
            updatedCandidateID = await generateCandidateID(jypCity);
          } else {
            updatedCandidateID = candidateID;
          }

          stagesSelected = {
            ...candidateData.stagesSelected,
            [shortlistStage]: true,
          };
        } else if (shortlistStage === 'researchActivity') {
          stagesSelected = {
            ...candidateData.stagesSelected,
            personalInterview: true,
            researchActivity: true,
          };
        } else {
          stagesSelected = { ...candidateData.stagesSelected, [shortlistStage]: true };
        }

        if (shortlistStage !== 'selected') {
          if (updatedCandidateID) {
            // eslint-disable-next-line no-await-in-loop
            await candidate.update({
              candidateID: updatedCandidateID,
              stagesSelected,
            });
          }
          // eslint-disable-next-line no-await-in-loop
          await candidate.update({
            stagesSelected,
          });
          // eslint-disable-next-line no-await-in-loop
          await axios.post(`${API_BASE_URL}/notifications/sendSMSOnRoundShortlist/`, {
            round: shortlistStage,
            to: candidateData.contactNumber,
            candidateID: updatedCandidateID || candidateData.candidateID,
            jypCity: candidateData.jypCity,
          });

          // eslint-disable-next-line no-await-in-loop
          await axios.post(`${API_BASE_URL}/notifications/sendEmailOnRoundShortlist/`, {
            round: shortlistStage,
            email: candidateData.email,
            candidateName: candidateData.fullName,
            candidateID: updatedCandidateID || candidateData.candidateID,
            jypCity: candidateData.jypCity,
          });
        } else if (candidateData.quiz.score === null) {
          shortlistErrors[id] = `Candidate with id ${id} has not cleared the selection quiz`;
        } else if (candidateData.knowledgeTest.score === null) {
          shortlistErrors[id] = `Candidate with id ${id} has not cleared the knowledge test`;
        } else if (candidateData.groupDiscussion.score === null) {
          shortlistErrors[
            id
          ] = `Candidate with id ${id} has not cleared the group discussion round`;
        } else if (candidateData.personalInterview.score === null) {
          shortlistErrors[
            id
          ] = `Candidate with id ${id} has not cleared the personal interview round`;
        } else if (candidateData.researchActivity.score === null) {
          shortlistErrors[
            id
          ] = `Candidate with id ${id} has not cleared the research activity round`;
        } else {
          // eslint-disable-next-line no-await-in-loop
          await candidate.update({
            stagesSelected,
          });
          // eslint-disable-next-line no-await-in-loop
          await axios.post(`${API_BASE_URL}/notifications/sendSMSOnRoundShortlist/`, {
            round: shortlistStage,
            to: candidateData.contactNumber,
            candidateID: updatedCandidateID || candidateData.candidateID,
            jypCity: candidateData.jypCity,
          });

          // eslint-disable-next-line no-await-in-loop
          await axios.post(`${API_BASE_URL}/notifications/sendEmailOnRoundShortlist/`, {
            round: shortlistStage,
            email: candidateData.email,
            candidateName: candidateData.fullName,
            candidateID: updatedCandidateID || candidateData.candidateID,
            jypCity: candidateData.jypCity,
          });
        }
      }
    } catch (error) {
      shortlistErrors[id] = `Candidate with id ${id} could be not be shortlisted`;
    }
  }

  if (Object.keys(shortlistErrors).length > 0) {
    return {
      success: false,
      data: {
        failedIds: Object.keys(shortlistErrors),
        errors: shortlistErrors,
      },
    };
  }

  return {
    success: true,
    data: {
      message: 'Candidates successfully shortlisted',
    },
  };
};



// WEBPACK FOOTER //
// ./src/services/shortlistService.js